// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------
export const INITIAL_STATE: {
    [key: string]: string[];
} = {};

export type SelectedShippingOfferStoreType = Readonly<typeof INITIAL_STATE>;

export function _getSelectedShippingOfferData(
    state: any,
    { payload }: { payload: any }
): SelectedShippingOfferStoreType {
    const newState = { ...state.selectedShippingOffer, ...payload };
    if (payload) {
        return { ...state, selectedShippingOffer: newState };
    }
    return state;
}
export function _resetSelectedShippingOfferData(
    state: any,
    { payload }: { payload: any }
): SelectedShippingOfferStoreType {
    return { ...state, selectedShippingOffer: {} };
}
